import { Link } from 'react-router-dom';

export default function ArticleCTASection() {
  const articles = [
    {
      id: 'poradnik-kakobuy',
      title: 'Kompletny Przewodnik Kakobuy Spreadsheet',
      desc: 'Wszystko, co musisz wiedzieć o Kakobuy Spreadsheet — od pierwszych kroków po zaawansowane strategie.',
      readTime: '10 min',
      image: 'https://readdy.ai/api/search-image?query=Warm%20inviting%20photo%20of%20an%20open%20laptop%20on%20a%20light%20wood%20desk%20showing%20a%20colorful%20spreadsheet%20interface%20next%20to%20a%20cup%20of%20tea%20and%20a%20small%20succulent%20plant%20natural%20morning%20sunlight%20streaming%20through%20window%20creating%20cozy%20productive%20atmosphere%20lifestyle%20photography%20with%20soft%20warm%20tones%20and%20organic%20textures&width=600&height=400&seq=article-card-guide-v2&orientation=landscape',
    },
    {
      id: 'jak-zaczac',
      title: 'Jak Zacząć — Poradnik dla Początkujących',
      desc: 'Krok po kroku przez proces pierwszego zamówienia. Dowiedz się jak założyć konto i znaleźć najlepsze produkty.',
      readTime: '8 min',
      image: 'https://readdy.ai/api/search-image?query=Friendly%20step%20by%20step%20guide%20concept%20photo%20with%20a%20numbered%20list%20on%20a%20notepad%20next%20to%20a%20smartphone%20showing%20a%20shopping%20app%20interface%20a%20cup%20of%20coffee%20and%20reading%20glasses%20on%20a%20light%20oak%20table%20soft%20morning%20light%20from%20a%20window%20beginner%20friendly%20encouraging%20atmosphere%20with%20warm%20natural%20tones&width=600&height=400&seq=article-card-start-v2&orientation=landscape',
    },
    {
      id: 'bezpieczenstwo-zakupow',
      title: 'Bezpieczeństwo Zakupów przez Kakobuy',
      desc: 'Wszystko o bezpieczeństwie — od weryfikacji sprzedawców, przez zdjęcia QC, aż po bezpieczne płatności.',
      readTime: '9 min',
      image: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20modern%20security%20shield%20icon%20displayed%20on%20a%20tablet%20screen%20placed%20on%20a%20clean%20white%20desk%20with%20a%20small%20padlock%20and%20a%20product%20inspection%20checklist%20printed%20on%20paper%20soft%20reassuring%20natural%20light%20professional%20trustworthy%20atmosphere%20with%20clean%20minimalist%20aesthetic%20and%20subtle%20warm%20highlights&width=600&height=400&seq=article-card-safety-v2&orientation=landscape',
    },
    {
      id: 'najlepsze-kategorie',
      title: 'Najlepsze Kategorie Produktów',
      desc: 'Przegląd wszystkich 14 kategorii produktowych. Sprawdź, co najbardziej opłaca się kupować z Chin.',
      readTime: '7 min',
      image: 'https://readdy.ai/api/search-image?query=Organized%20colorful%20flatlay%20of%20fashion%20product%20miniatures%20grouped%20by%20categories%20on%20a%20clean%20white%20surface%20with%20handwritten%20category%20labels%20on%20kraft%20paper%20cards%20next%20to%20each%20group%20sneakers%20clothing%20accessories%20watches%20cheerful%20retail%20visual%20merchandising%20aesthetic%20with%20soft%20natural%20daylight%20and%20vibrant%20warm%20tones&width=600&height=400&seq=article-card-categories-v2&orientation=landscape',
    },
    {
      id: 'wysylka-polska',
      title: 'Kakobuy Wysyłka do Polski',
      desc: 'Koszty, metody i czas dostawy. Wszystko, co musisz wiedzieć o wysyłce Kakobuy do Polski.',
      readTime: '6 min',
      image: 'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20scene%20with%20a%20cardboard%20shipping%20box%20featuring%20a%20world%20map%20illustration%20showing%20a%20route%20from%20China%20to%20Poland%20a%20measuring%20tape%20a%20shipping%20label%20and%20a%20tablet%20showing%20delivery%20tracking%20information%20warm%20natural%20lighting%20professional%20logistics%20and%20ecommerce%20aesthetic%20with%20cardboard%20brown%20and%20clean%20white%20tones&width=600&height=400&seq=article-card-shipping-v2&orientation=landscape',
    },
    {
      id: 'poradnik-kakobuy',
      title: 'Kakobuy vs Inne Platformy — Porównanie',
      desc: 'Porównanie Kakobuy z Sugargoo, Pandabuy i innymi agentami. Która platforma jest najlepsza?',
      readTime: '8 min',
      image: 'https://readdy.ai/api/search-image?query=Clean%20comparison%20concept%20photo%20showing%20two%20tablets%20side%20by%20side%20on%20a%20white%20desk%20each%20displaying%20different%20ecommerce%20platform%20interfaces%20with%20handwritten%20pros%20and%20cons%20lists%20on%20sticky%20notes%20between%20them%20soft%20natural%20window%20light%20creating%20a%20balanced%20analytical%20atmosphere%20editorial%20style%20with%20warm%20neutral%20tones&width=600&height=400&seq=article-card-compare-v2&orientation=landscape',
    },
    {
      id: 'jak-zaczac',
      title: 'Jak Znaleźć Ukryte Perełki w Arkuszu',
      desc: 'Zaawansowane strategie wyszukiwania najlepszych okazji. Sekrety doświadczonych użytkowników.',
      readTime: '7 min',
      image: 'https://readdy.ai/api/search-image?query=Inspiring%20photo%20of%20a%20magnifying%20glass%20placed%20over%20a%20colorful%20spreadsheet%20printed%20on%20paper%20revealing%20hidden%20highlighted%20rows%20with%20sparkle%20annotations%20scattered%20gemstones%20crystals%20on%20a%20wooden%20desk%20warm%20directional%20lighting%20creating%20a%20treasure%20hunt%20discovery%20mood%20editorial%20photography%20with%20rich%20warm%20tones%20and%20intriguing%20atmosphere&width=600&height=400&seq=article-card-gems-v2&orientation=landscape',
    },
    {
      id: 'poradnik-kakobuy',
      title: 'Kakobuy Spreadsheet dla Zaawansowanych',
      desc: 'Zaawansowane funkcje arkusza, triki i strategie dla doświadczonych użytkowników Kakobuy.',
      readTime: '10 min',
      image: 'https://readdy.ai/api/search-image?query=Professional%20workspace%20setup%20with%20multiple%20monitors%20showing%20complex%20spreadsheet%20data%20and%20analytics%20dashboards%20a%20leather%20notebook%20with%20handwritten%20formulas%20and%20a%20premium%20mechanical%20pencil%20warm%20desk%20lamp%20glow%20creating%20a%20focused%20expert%20atmosphere%20modern%20tech%20aesthetic%20with%20warm%20ambient%20lighting%20and%20sophisticated%20mood&width=600&height=400&seq=article-card-advanced-v2&orientation=landscape',
    },
    {
      id: 'bezpieczenstwo-zakupow',
      title: 'Opinie o Kakobuy — Czy Warto?',
      desc: 'Szczera analiza zalet i wad platformy. Prawdziwe opinie użytkowników i ekspertów.',
      readTime: '6 min',
      image: 'https://readdy.ai/api/search-image?query=Authentic%20review%20concept%20photo%20with%20a%20smartphone%20displaying%20five%20star%20ratings%20and%20user%20review%20text%20next%20to%20a%20notebook%20with%20handwritten%20pros%20and%20cons%20columns%20and%20a%20pen%20on%20a%20warm%20wooden%20surface%20soft%20natural%20lighting%20honest%20transparent%20editorial%20aesthetic%20with%20warm%20neutral%20tones%20and%20genuine%20approachable%20mood&width=600&height=400&seq=article-card-reviews-v2&orientation=landscape',
    },
  ];

  const articleRoutes: Record<string, string> = {
    'poradnik-kakobuy': '/poradnik-kakobuy',
    'jak-zaczac': '/poradnik-kakobuy/jak-zaczac',
    'bezpieczenstwo-zakupow': '/poradnik-kakobuy/bezpieczenstwo-zakupow',
    'najlepsze-kategorie': '/poradnik-kakobuy/najlepsze-kategorie',
    'wysylka-polska': '/poradnik-kakobuy/wysylka-polska',
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Artykuły i Poradniki Kakobuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Pogłębiona wiedza o Kakobuy Spreadsheet — poradniki, analizy i praktyczne wskazówki dla każdego użytkownika
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {articles.map((article, idx) => {
            const link = articleRoutes[article.id] || '/poradnik-kakobuy';
            return (
              <Link
                key={idx}
                to={link}
                className="group bg-white rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 hover:shadow-sm transition-all duration-200 cursor-pointer"
              >
                <div className="relative overflow-hidden h-40 md:h-48">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute top-3 right-3 px-2.5 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-600">
                    {article.readTime}
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2">
                    {article.desc}
                  </p>
                  <div className="mt-3 flex items-center gap-1.5 text-primary-600 text-xs font-medium">
                    <span>Czytaj więcej</span>
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/poradnik-kakobuy"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-800 text-sm font-semibold rounded-full border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Zobacz Wszystkie Artykuły
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}